import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'

import styles from './Warning.scss'

export const TYPES = {
    warning: 'warning',
    alert: 'alert',
    message: 'message',
}

const Warning = (props) => {
    const className = classNames(styles.base, styles[`base__${TYPES[props.type]}`])
    return (
        <p className={className}>
            {props.children}
        </p>
    )
}

Warning.propTypes = {
    type: PropTypes.oneOf(Object.keys(TYPES)).isRequired,
}

Warning.defaultProps = {
    type: TYPES.warning,
}

export default Warning



// WEBPACK FOOTER //
// ./components/Warning/Warning.jsx